import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { userKeys } from '../../cache-keys/userKeys';

export function useAddRecentlyOpenedApplication() {
  const { state } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({
      marketCountry,
      applicationID,
      humanReadableID,
    }: {
      marketCountry: string;
      applicationID: string;
      humanReadableID: string;
    }) =>
      ace_api.upsert(api)({
        ClientID: state.user.clientID,
        MarketCountry: marketCountry,
        LoanApplicationID: applicationID,
        HumanReadableID: humanReadableID,
      }),
    {
      onSuccess: (_, { marketCountry }) =>
        Promise.all([
          client.invalidateQueries(
            userKeys.recentlyOpenedApplications({
              user: state.user.clientID,
              country: marketCountry,
            }),
          ),
        ]),
    },
  );
}
